/**
 * Converts formerly used dayjs format string to date-fns format string
 * Example: DD.MM.YYYY -> dd.MM.yyyy
 */
export const convertDateFormat = (dateFormatString: string) =>
  dateFormatString.replaceAll('Y', 'y').replaceAll('D', 'd');
